import { createReducer, on } from '@ngrx/store';
import { cargaComentarios, resetComentarios } from './actions';
import { iComentarios } from '../../entrada/entrada.interface';

export const initialState: iComentarios[] = [];

export const comentariosReducer = createReducer(
    initialState,
    on(cargaComentarios, (state, payload) => {
        return [...payload.oComentarios]; 
    }),
    on(resetComentarios, (state,  payload) => {
        return initialState;
    })
);